module.exports = __webpack_public_path__ + "static/img/img-4.8954b187.png";